import { Navigate, Outlet } from "react-router-dom";
import { LoginInfo } from "@/services/login-service/entities/LoginEntity.ts";

export const PrivateRoute = () => {
  const loginInfo: LoginInfo = new LoginInfo(
    JSON.parse(localStorage.getItem("LOGIN_INFO") || "{}")
  );
  return loginInfo && loginInfo.accessToken ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
};
